<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
import { removeCookie } from "@/utils/cokiesFun";
export default {
    name: "App",
    data() {
        return {};
    },
    components: {
    },
    computed: {
    },
    mounted() {
    },
    destroyed() {
        localStorage.removeItem('tabsValue');// Tabs清空
        removeCookie('isLogin');// 登陆状态清空
        console.log('App destroyed');
    },
    methods: {},
};
</script>
<style lang="less">
// 引入初始化css文件
@import "./assets/css/base.less";
@import "./assets/css/element_updata.less";

body,
html,
#app {
    width: 100%;
    height: 100vh;
    margin-bottom: 0px;
    margin-bottom: constant(safe-area-inset-bottom);
    margin-bottom: env(safe-area-inset-bottom);
    font-family: "Microsoft YaHei";
    /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
    ::-webkit-scrollbar {
        width: 6px; /*对垂直流动条有效*/
        height: 6px; /*对水平流动条有效*/
    }
    /*定义滚动条的轨道颜色、内阴影及圆角*/
    ::-webkit-scrollbar-track {
        opacity: 0;
    }
    /*定义滑块颜色、内阴影及圆角*/
    ::-webkit-scrollbar-thumb {
        border-radius: 7px;
        background-color: #d8d8d8;
    }

    /*清除水印 高德地图*/
    .amap-logo {
        display: none !important;
        visibility: hidden !important;
    }
    .amap-copyright {
        display: none !important;
        visibility: hidden !important;
    }
}
</style>
